import { useEffect } from 'react';

/** Sets the tab's title while mounted. Null leaves it to the page around (TOM-357's board column). */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    if (title === null) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
